// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3Dvfh","label":"CategoryService_label__1if0S","location":"CategoryService_location__z1oKN"};